"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const serverFunctions_1 = require("../../firebase/serverFunctions");
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const clientAppOnAuthenticated_1 = __importDefault(require("../clientAppOnAuthenticated"));
const buildCallableSignIn = (args) => async ({ functionId, entryVars: { email, name, password, phone, }, callbacks, executeProcesses, processor, store, }) => {
    const validateEmail = /\S+@\S+/;
    if (!(0, valueIsString_1.default)(email)
        || !(0, valueIsString_1.default)(password)
        || !(0, valueIsString_1.default)(name)
        || !email
        || !name
        || !password) {
        executeProcesses(functionId, callbacks.errorProcess, 'Not all required params are added');
        return;
    }
    if (phone !== undefined && !(0, valueIsString_1.default)(phone)) {
        executeProcesses(functionId, callbacks.errorProcess, 'The phone number can only be a string');
        return;
    }
    if (!validateEmail.test(email) || password.length < 6) {
        executeProcesses(functionId, callbacks.errorProcess, 'Not all required params are valid');
        return;
    }
    try {
        const state = store.getState();
        const projectId = (0, appStateSelectProjectId_1.default)(state);
        const appId = (0, appStateSelectAppId_1.default)(state);
        if (!processor.root.isInDevelopment) {
            await processor.root.firebase.auth().createUserWithEmailAndPassword(email, password);
            await (0, clientAppOnAuthenticated_1.default)({
                appId,
                processor,
                projectId,
                optionalUserValues: {
                    name,
                    phone,
                },
            });
            executeProcesses(undefined, callbacks.sucessProcess);
            return;
        }
        const firebaseFunctions = processor.root.firebase.functions();
        const data = await (0, serverFunctions_1.rendererSignIn)(firebaseFunctions)({
            email,
            name,
            password,
            phone,
            projectId,
            appId,
        });
        if (!data.success) {
            executeProcesses(functionId, callbacks.errorProcess, data.error);
        }
        else if (data.userIsAlreadySignedIn) {
            executeProcesses(functionId, callbacks.userAlreadySignedIn, 'User is already registered');
        }
        else {
            // Calls the logIn part
            const dataLogIn = await (0, serverFunctions_1.rendererLogIn)(firebaseFunctions)({
                projectId,
                appId,
                email,
                password,
            });
            if (!dataLogIn.success || !dataLogIn.customToken) {
                executeProcesses(functionId, callbacks.errorProcess, dataLogIn.error);
                return;
            }
            await processor.root.firebase.auth().signInWithCustomToken(dataLogIn.customToken);
            await (0, clientAppOnAuthenticated_1.default)({
                appId,
                processor,
                projectId,
                optionalUserValues: {
                    phone,
                    name,
                },
            });
            if ((args === null || args === void 0 ? void 0 : args.onUserLoggedInDevelopment) && processor.root.isInDevelopment) {
                await args.onUserLoggedInDevelopment({ appId });
            }
            executeProcesses(undefined, callbacks.sucessProcess);
        }
    }
    catch (error) {
        const errorCode = (0, getValueByPathFromUnknown_1.default)(error, ['code']);
        if (errorCode === 'auth/email-already-in-use') {
            executeProcesses(functionId, callbacks.userAlreadySignedIn, 'User is already registered');
        }
        else {
            executeProcesses(functionId, callbacks.errorProcess, `${error}`);
        }
    }
};
exports.default = buildCallableSignIn;
